






import { Component, Vue, Watch } from "vue-property-decorator";
import { getters as gettersGlobal } from "@/observables/Global";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
stockInit(Highcharts);

@Component({
  components: { Chart }
})
export default class extends Vue {
  $refs!: {
    vue: Vue;
    chartContainer: HTMLElement;
  };

  /* Data */
  height = 0;
  chartOptions = {};

  /* Computed */
  get histogramData(): object {
    const series = JSON.parse(JSON.stringify(gettersGlobal.getHistogramData()));

    /* Converte os valores de segundos para minutos. */
    for (const key in series) {
      series[key] = parseFloat((parseFloat(series[key]) / 60).toFixed(2));
    }

    return series;
  }

  get totalClasses() {
    /* Retorna a partir do objeto a quantidade de barras que o gráfico terá. */
    return Object.keys(gettersGlobal.getHistogramData()).length - 1;
  }

  get color(): string[] {
    return gettersGlobal.getColors();
  }

  /* Hooks */
  mounted() {
    /* Inicialmente adiciona um função de renderização ao evento resize da janela. */
    window.addEventListener("resize", this.onRenderChart);
    /* Chama a função pela primeira vez para renderizar o gráfico manualmente. */
    this.onRenderChart();
  }

  beforeDestroy() {
    /* Removo o evento caso o componente seja fechado. */
    window.removeEventListener("resize", this.onRenderChart, false);
  }

  /* Methods */
  onRenderChart() {
    const height = this.$refs.chartContainer.clientHeight + 10;
    this.chartOptions = this.buildChartOptions(height);
  }

  buildChartOptions(p_Height: number) {
    return {
      chart: {
        type: "column",
        marginLeft: 40,
        marginTop: 40,
        height: p_Height
      },
      title: {
        text: ""
      },
      colors: this.color,
      xAxis: {
        type: "category",
        title: {
          text: null
        },
        min: 0,
        max: this.totalClasses,
        scrollbar: {
          enabled: false
        },
        tickLength: 0
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
          align: "high"
        }
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          }
        },
        column: {
          pointPadding: 0,
          borderWidth: 0,
          groupPadding: 0.05
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: "",
          data: Object.entries(this.histogramData)
        }
      ],
      tooltip: {
        backgroundColor: "#FFFFFF",
        borderColor: "#333",
        borderRadius: 5,
        shadow: false,
        y: 0,
        formatter: function(): string {
          return "<b>" + this.y + " min.</b>";
        },
        style: {
          color: "#333333",
          cursor: "default",
          fontSize: "14px",
          whiteSpace: "nowrap"
        }
      }
    };
  }

  /* Watch */
  @Watch("histogramData", { deep: true }) onHistogramData() {
    /* Caso haja quaisquer alteração nos dados de HistogramData será novamente carregado os valores para "series"
    e "categories". */
    this.onRenderChart();
  }
}
